import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { API_VERSION_CENTAVOS, API_VERSION_HEADER, HOMOLOG_HEADER } from '../../app.constants';


@Injectable()
export class AddHeaderVersionInterceptor implements HttpInterceptor {


  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const setHeaders: {[key:string]: string} = {}

    if (!request.headers.get('X-dg-app-version')) {
      setHeaders['X-dg-app-version'] = '5.3.0+430';//'0.0.0+405';
    }
    // if (!request.headers.get('minimumAppBuildNumber')) {
      // setHeaders['minimumAppBuildNumber'] = '380';
    // }
    if(!request.headers.has('X-Dg-Ticket-app-v2') &&  environment.version){
      setHeaders['X-Dg-Ticket-app-v2'] = environment.version;
    }
    // ADR-0013: o carrinho divide os valores da cotação por 100, então precisamos pedir o
    // contrato em centavos. A guarda não é decorativa: dois `x-dg-api-version` na mesma
    // request viram "2026-08-12,2026-08-12" no bind do Spring e a API responde 400.
    if (!request.headers.has(API_VERSION_HEADER)) {
      setHeaders[API_VERSION_HEADER] = API_VERSION_CENTAVOS;
    }
    if(sessionStorage && sessionStorage.getItem(HOMOLOG_HEADER)){
      setHeaders[HOMOLOG_HEADER] = '123'
    }

    request = request.clone({ setHeaders });
    return next.handle(request);
  }
}
